import { Component, OnDestroy } from '@angular/core';

@Component({
    selector: 'tnb-netzzuordnungen-page',
    templateUrl: './netzzuordnungen-page.component.html',
    styleUrls: [
        './netzzuordnungen-page.component.scss',
    ],
    standalone: false,
})
export class NetzzuordnungenPageComponent implements OnDestroy {
    private componentDestroyed = false;

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }
}
